// src/api/client.js
//import axios from "axios";

//const api = axios.create({
 // baseURL:  "http://localhost:5000/api", 
 // headers: {
 //   "Content-Type": "application/json",
  //},
//});

//export default api;


import axios from "axios";
console.log("API BASE URL :",process.env.REACT_APP_API_BASE_URL);

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
